/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 10/02/22
 */

import { DependencyList, useEffect, useRef } from 'react';

/**
 * Run function after a set delay, restarting the wait when dependencies change
 * @param callback Callback to run
 * @param delay Time in milliseconds to wait
 * @param dependencies
 * @returns Function to cancel delay
 */
export const useDebounce = (callback: () => void, delay: number, dependencies: DependencyList): (() => void) => {
    const timeoutRef = useRef<number>();
    useEffect(() => {
        const timeout = window.setTimeout(() => {
            callback();
        }, delay);
        timeoutRef.current = timeout;
        return () => {
            clearTimeout(timeout);
        };
    }, dependencies);

    return () => {
        clearTimeout(timeoutRef.current);
    };
};
